import { render } from "./Header3DLogo2.vue?vue&type=template&id=672530d3&scoped=true"
import script from "./Header3DLogo2.vue?vue&type=script&lang=js"
export * from "./Header3DLogo2.vue?vue&type=script&lang=js"

import "./Header3DLogo2.vue?vue&type=style&index=0&id=672530d3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672530d3"]])

export default __exports__